export const cloudStorageTopics: string[] = [
    "Cloud Storage",
    "Backup Online",
    "Drive Empresarial",
    "S3",
    "Espacio en la Nube",
    "Google Drive",
    "OneDrive",
    "Dropbox",
    "Data Warehouse",
    "Object Storage",
    "File Storage",
    "NAS",
    "SAN",
    "Block Storage",
    "Respaldo en la Nube",
    "Copias de Seguridad",
    "Data Lake",
    "Big Data Storage",
    "Almacenamiento Distribuido",
    "Encriptación de Datos",
    "Disaster Recovery Storage",
    "Secure Cloud Backup"
  ];